import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Img from "../../../images/locationgcc/sa/digital.webp";

function Banner(props) {
  return (
    <div className="enablement p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h2>
                Business Digitization with TekRevol: A Leading App Development
                Company in KSA
              </h2>
              <p>
                TekRevol demonstrates proficiency in multiple app development
                development services. Having 5 years of proven experience in the
                global industry we have served multiple businesses with
                market-leading advancements. We utilize rich feature
                customizations with elite coding standards by our app developers
                in KSA. Our user-centric approach makes us the first choice of
                clients to ensure their business sustainability.
              </p>
              <p>
                As a predominant KSA mobile app development company, we strongly
                believe embracing digital transformation can help businesses
                stand out in your relevant industry. We facilitate all sorts of
                businesses with innovative, user-friendly digital services and
                solutions that help them generate massive revenues over time.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                {" "}
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <LazyLoadImage
              src={Img}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
